export default "__VITE_ASSET__D2l6EYhl__"